var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',[_vm._v(" "+_vm._s(_vm.codename)+" v"+_vm._s(_vm.version)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }